import { render, staticRenderFns } from "./Tagify.vue?vue&type=template&id=30eff950&"
import script from "./Tagify.vue?vue&type=script&lang=js&"
export * from "./Tagify.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/form.css?vue&type=style&index=0&lang=css&"
import style1 from "./Tagify.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports